import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { jwtDecode } from "jwt-decode";
import { JwtPayload } from "../../core/core/model/jwt-payload.model";

@Injectable({
  providedIn: "root",
})
export class AuthRoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = sessionStorage.getItem("token");

    if (!token) {
      return this.navigateToLogin(state);
    }

    try {
      const decodedToken = jwtDecode<JwtPayload>(token);

      if (decodedToken.exp && Date.now() >= decodedToken.exp * 1000) {
        throw new Error("Token expirado");
      }

      // Extraer authorities del token JWT
      const authorities = decodedToken.authorities;
      const roles: string[] = Array.isArray(authorities)
        ? authorities
        : authorities ? [authorities] : [];

      const expectedRoles = route.data["roles"] as string[];

      if (expectedRoles.some((role) => roles.includes(role))) {
        return true;
      }

      // Si no tiene el rol requerido
      return this.navigateToUnAuthorized();
    } catch (error) {
      console.error("Error al decodificar el token:", error);

      return this.navigateToLogin(state);
    }
  }

  private navigateToLogin(state: RouterStateSnapshot): boolean {
    this.router.navigate(["/auth/oauth-redirect"], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }

  private navigateToUnAuthorized(): boolean {
    this.router.navigate(["/auth/unauthorized"]);
    return false;
  }
}
